var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"ma-3"},[_c('searchFilter')],1),_c('v-card',{staticClass:"ma-3"},[_c('tableData')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }